import { CommonModule } from '@angular/common';
import { Component,  OnInit } from '@angular/core';
import { FormBuilder,  ReactiveFormsModule,  Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ProductoService } from 'src/app/services/producto/producto.service';

@Component({
  selector: 'app-crear-producto',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './crear-producto.component.html',
  styleUrl: './crear-producto.component.css',
  standalone: true
})
export class CrearProductoComponent implements OnInit{
loading = false;
  error = '';
  usuarioId:number =0;
  form = this.fb.group({
    nombre: ['', Validators.required],
    precio: [0, [Validators.required, Validators.min(1)]],
    stock: [0, [Validators.required, Validators.min(0)]],
    codigoBarras: ['', Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    private productoService: ProductoService,
    private currentUserService: CurrentUserService,
    private router: Router
  ) {}

  crear() {
    if (this.form.invalid) return;
    this.loading = true;
    const usuarioId = Number(localStorage.getItem('userId')) || 0;

    this.productoService.crearProducto(usuarioId,{
      nombre: this.form.value.nombre || '',
      precio: this.form.value.precio || 0,
      usuarioId:this.usuarioId,
      productoId: 0,
      eliminado: false,
      stock: this.form.value.stock || 0,
      codigoBarras: this.form.value.codigoBarras || '',
      fechaAlta: new Date(),
      fechaModificacion: new Date()
    }).subscribe({
      next: () => (alert("Producto agregado con éxito"),this.router.navigate(['/productos'])),
      error: () => {
        this.error = 'Error al crear producto';
        this.loading = false;
      }
    });
  }

  cancelar() {
    this.router.navigate(['/productos']);
  }
  ngOnInit(): void {
    const usuarioId = this.currentUserService.getUsuarioId();
    if (!usuarioId) {
      alert('Debes iniciar sesión para acceder a esta sección.');
      this.router.navigate(['/login']);
      return;
    }
    this.usuarioId = +usuarioId;
  }
  volverAtras() {
    this.router.navigate(['/productos']);
  }
}
